import React, { Component } from "react";
import Layout from "components/Layout/Layout";
import { Col } from "react-bootstrap";
import "./UserAdminDashboard.scss";
import UserAdminLeftSection from "components/UserAdminLeftSection/UserAdminLeftSection";
import UserAdminRightSection from "components/UserAdminRightSection/UserAdminRightSection";

export default class UserAdminDashboard extends Component {
  render() {
    return (
      <Layout className="user-admin-dashboard-page">
        <div className="user-admin-dashboard">
          <Col className="user-admin-summary-column" xs="3">
            <UserAdminLeftSection />
          </Col>
          <Col className="user-admin-content-column">
            <UserAdminRightSection />
          </Col>
        </div>
      </Layout>
    );
  }
}
